import { render, staticRenderFns } from "./DispaHeader.vue?vue&type=template&id=0e31d3c9&"
import script from "./DispaHeader.vue?vue&type=script&lang=js&"
export * from "./DispaHeader.vue?vue&type=script&lang=js&"
import style0 from "./DispaHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports